module.exports = __webpack_public_path__ + "static/media/photo-1497350166004-48ec9adb78bb.f8ff75a2.jfif";